import { Menu } from '../models/Menu';

export const menuList: Menu[] = [
  {
    name: 'Dashboard',
    link: '/',
    icon: 'icon-grid',
  },
  {
    name: 'Data',
    link: '/data',
    icon: 'icon-circular-graph',
  },
  {
    name: 'Listings',
    link: '/listings',
    icon: 'icon-list',
  },
  {
    name: 'Clients',
    link: '/clients',
    icon: 'icon-user',
  },
  {
    name: 'Bills',
    link: '/bills',
    icon: 'icon-text-document',
  },
  {
    name: 'Settings',
    link: '/settings',
    icon: 'icon-cog',
  },
];
